module.exports = __webpack_public_path__ + "static/media/sundance-white.9ca163cb.png";